import type { TFunction } from 'i18next'

import { DateErrors } from './Errors.enum'

const DATE_ERROR_TRANSLATION_KEYS: Record<keyof typeof DateErrors, string> = {
  INVALID_DATE: 'enterAValidDate',
  CLOSED: 'vendorIsClosed',
  CLOSED_LARGE_ORDER: 'vendorIsClosed',
  DATE_PAST: 'thisDateIsntAvailable',
}

export const translateDateError = (t: TFunction, error: keyof typeof DateErrors): string =>
  t(`marketplace:${DATE_ERROR_TRANSLATION_KEYS[error]}`)
